/**
 * @name eventsTargetTypes
 * @enum {string}
 */
export const eventsTargetTypes = {
  RoundFinished: 'RoundFinished',
  ResultReport: 'ResultReport',
  GetInitialResult: 'GetInitialResult',
};

/**
 * @name handleTargetTypes
 * @enum {string}
 */
export const handleTargetTypes = {
  GetInitialState: 'GetInitialState',
};

export const roundStates = {
  roundStart: "roundStart",
  betClosed: "betClosed",
  roundFinished: "roundFinished"
}